"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
const react_intl_1 = require("react-intl");
exports.messages = (0, react_intl_1.defineMessages)({
    feeError: {
        id: 'components/Reservation/CancellationPopup:feeError',
        defaultMessage: 'should be a number',
    },
});
//# sourceMappingURL=messages.js.map